<template>
  <div class="md:container md:mx-auto h-screen w-screen bg-white">
    <div class="section-title">
      {{ team.name }} - Nächste Ereignisse
    </div>
    <div
      v-if="items"
      class="text-4xl md:text-base md:text-1xl lg:text-base md:container md:mx-auto"
    >
      <div
        v-for="item in items"
        :key="item"
        class="flex flex-row"
      >
        <span class="mr-2">{{ item.time|formatDate }}</span> <span class="flex-grow font-bold">{{ item.title }}</span>
        <span>{{ item.location }}</span>
        <span>
          <a
            :href="item.link"
            class="text-blue"
            target="_blank"
          >Link</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamEventsPub',
    data () {
        return {
            teamId: '',
            team: null,
            items: []
        }
    },
    async mounted () {
        this.teamId = this.$route.params.id
        const response = await apiService.getPubTeamEvents(this.teamId)
        this.items = response.data.events
        this.team = response.data.team
    }
}
</script>

<style scoped>

</style>